import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionFinalizeLegacyAccount($input: FinalizeLegacyAccountInput!) {
    actionFinalizeLegacyAccount(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      finalized
    }
  }
  ${ErrorMessageInfo}
`;
